import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { fuseAnimations } from "@fuse/animations";
import { TranslateService } from "@ngx-translate/core";
import { SimpleCardComponent } from "app/helper-components/simple-card/simple-card.component";
import { HelperService } from "app/helpers/helper.service";
import { UserDataService } from "app/helpers/user-data.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-chief-barrack-executive",
  templateUrl: "./chief-barrack-executive.component.html",
  styleUrls: ["/src/app/helper-styles/simple-navigation-cards-container.scss"],
  animations: fuseAnimations,
})
export class ChiefBarrackExecutiveComponent implements OnInit, AfterViewInit {
  @ViewChild("cards_holder", { read: ViewContainerRef })
  cards_holder: ViewContainerRef;
  parameters: any;

  cards: {};
  subscription: Subscription;

  constructor(
    private cdr: ChangeDetectorRef,
    private resolver: ComponentFactoryResolver,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private helper: HelperService,
    private userDataService: UserDataService,
    private translateService: TranslateService,
  ) {
    this.cards = {};
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((data) => {
      this.parameters = this.helper.getParameters(data["_v"]);
    });
  }

  ngAfterViewInit(): void {
    this.addDefaultOptions();

    this.cdr.detectChanges();
  }

  addPlaceHolders(): void {
    for (let index = 0; index < 10; index++) {
      this.addCard("").instance.setAsPlaceHolder();
    }
  }

  addDefaultOptions() {
    var rights = this.userDataService.userData.rights[
      this.parameters.party_post_id
    ];

    if (this.helper.viewAccessAvailable(rights, this.parameters, 46)) {
      this.addCard("Countries").instance.callback = () => {
        let key = this.helper.storePageData(this.parameters);
        this.router.navigateByUrl("country/list?_v=" + key);
      };
    }
    if (this.helper.viewAccessAvailable(rights, this.parameters, 54)) {
      this.addCard("Cheif Roles").instance.callback = () => {
        this.parameters.party_group_id = 21;
        this.parameters.place_id = 1000;
        let key = this.helper.storePageData(this.parameters);
        this.router.navigateByUrl("/post/list?_v=" + key);
      };
    } else {
    }
  }

  addCard(title: string): ComponentRef<SimpleCardComponent> {
    const componentFactory = this.resolver.resolveComponentFactory(
      SimpleCardComponent,
    );
    const componentRef = this.cards_holder.createComponent(componentFactory);
    componentRef.instance.card_title = title;

    if (title) {
      var searchKey = title;
      this.translateService.get(title).subscribe((res: string) => {
        searchKey += ", " + res;
      });
      this.cards[searchKey] = componentRef;
    }
    return componentRef;
  }

  filterCardsByTerm = (searchTerm: string) => {
    Object.keys(this.cards).forEach((value: string, index: number) => {
      if (searchTerm === "") {
        this.cards[value].instance.hideIt = false;
      } else {
        if (value.toLowerCase().includes(searchTerm)) {
          this.cards[value].instance.hideIt = false;
        } else {
          this.cards[value].instance.hideIt = true;
        }
      }
    });
  };

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }
}
